import { render, staticRenderFns } from "./itinerary_air_1.vue?vue&type=template&id=17d6794a&"
import script from "./itinerary_air_1.vue?vue&type=script&lang=js&"
export * from "./itinerary_air_1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/deploy/beta-web-new/web_head/releases/20260305082618/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17d6794a')) {
      api.createRecord('17d6794a', component.options)
    } else {
      api.reload('17d6794a', component.options)
    }
    module.hot.accept("./itinerary_air_1.vue?vue&type=template&id=17d6794a&", function () {
      api.rerender('17d6794a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/desktop/itineraries/itinerary_air_1.vue"
export default component.exports